import React from 'react';
import { JourneyRouteProps } from "./Interfaces";
import { useJourneyState } from '../context/JourneyContext';
import useParseStringToTemplate from '../../actions/parseStringToTemplateHook';

//Higher Order wrapper to pass props to route.
const JourneyRoute: React.FC<JourneyRouteProps> = ({ Route, path, passedProps, index, ...props }) => {
    const { journeyStore } = useJourneyState()
    // const { getParseTemplateScript } = useParseStringToTemplate()
    //console.log(passedProps)
    let tempProps = {
        ...props,
        ...passedProps
    }
    if (tempProps.hasOwnProperty("templateProps")) {
        //Dynamic Script Variables: If temlpateProps contains script, process for dynamic variables.
        if (tempProps.templateProps.hasOwnProperty("script")) {
            // tempProps.templateProps.script = getParseTemplateScript(passedProps.templateProps.script)
        }
        //Autonavigate to parent destination: If it has templateProps, is nextScreen missing or has a length less than 1.
        if (!tempProps.templateProps.hasOwnProperty("nextScreen") || tempProps.templateProps.nextScreen.length <= 1) {
            tempProps.parentDestination && (
                tempProps.templateProps.nextScreen = "../" + tempProps.parentDestination
            )
        }
    }
    return (
        <Route path={path} key={"route-" + path} index={index} {...tempProps} data={journeyStore}>
            {tempProps.children ? tempProps.children : null}
        </Route>
    )
}

export default JourneyRoute;